import { Button } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { ForumProps } from "./Forums";

interface Props {
    forum: ForumProps;
    onEditClicked: (id: string) => void;
    onDeleteClicked: (id: string) => void;
    onViewCategoriesClicked: (id: string) => void;
    onSecurityClicked: (id: string) => void;
}

const ForumDesktopItem: React.FC<Props> = ({
    forum,
    onEditClicked,
    onViewCategoriesClicked,
    onDeleteClicked,
    onSecurityClicked,
}) => {
    const [display, setDisplay] = useState<boolean>(false);

    /***************************************************
     * Event handlers
     ***************************************************/
    const toggleDisplay = useCallback(() => {
        setDisplay((currentDisplay) => !currentDisplay);
    }, []);

    const handleEditClicked = useCallback(() => {
        if (forum.id) {
            onEditClicked(forum.id);
        }
    }, [forum.id, onEditClicked]);

    const handleSecurityClicked = useCallback(() => {
        if (forum.id) {
            onSecurityClicked(forum.id);
        }
    }, [forum.id, onSecurityClicked]);

    const handleViewCategorieslicked = useCallback(() => {
        if (forum.id) {
            onViewCategoriesClicked(forum.id);
        }
    }, [forum.id, onViewCategoriesClicked]);

    const handleDeleteClicked = useCallback(() => {
        let id: string = "";
        if (forum.id) {
            id = forum.id;

            if (window.confirm("Are you sure you want to delete this forum?")) {
                onDeleteClicked(id);
            }
        }
    }, [forum.id, onDeleteClicked]);

    /***************************************************
     * Render
     ***************************************************/
    return (
        <div className="alternate-table-entry px-2">
            {/* Mobile */}
            <div className="d-block d-md-none w-100 py-2">
                {/* Normal information */}
                <div className="d-flex align-items-center">
                    <Button
                        variant="contained"
                        className="action-button dark-red-button rounded-0"
                        onClick={toggleDisplay}
                    >
                        {display ? (
                            <i className="fas fa-chevron-down" />
                        ) : (
                            <i className=" fas fa-chevron-right" />
                        )}
                    </Button>
                    <span className="ml-2 flex-grow-1">{forum.name}</span>
                </div>

                {/* Detailed information */}
                {display ? (
                    <div className="d-flex flex-column">
                        <span className="mt-2 font-small">Name</span>
                        <span>{forum.name}</span>
                        <span className="mt-2 font-small">Sort order</span>
                        <span>{forum.sortOrder}</span>
                        <span className="mt-2 font-small">Actions</span>
                        <div className="mt-2 d-flex">
                            <Button
                                variant="contained"
                                className="action-button bg-warning text-white rounded-0"
                                onClick={handleEditClicked}
                            >
                                <i className="fas fa-pencil-alt"></i>
                            </Button>
                            <Button
                                variant="contained"
                                className="ml-2 action-button bg-primary text-white rounded-0"
                                onClick={handleSecurityClicked}
                            >
                                <i className="fas fa-key"></i>
                            </Button>
                            <Button
                                variant="contained"
                                className="ml-2 action-button dark-red-button rounded-0"
                                onClick={handleViewCategorieslicked}
                            >
                                <i className="fas fa-bars"></i>
                            </Button>
                            <Button
                                variant="contained"
                                className="ml-2 action-button bg-danger text-white rounded-0"
                                onClick={handleDeleteClicked}
                            >
                                <i className="fas fa-trash"></i>
                            </Button>
                        </div>
                    </div>
                ) : null}
            </div>

            {/* Desktop */}
            <div className="d-none d-md-flex row w-100">
                <div className="d-flex align-items-center col-6">
                    <span>{forum.name}</span>
                </div>
                <div className="d-flex align-items-center col-4">
                    <span>{forum.sortOrder}</span>
                </div>
                <div className="d-flex align-items-center justify-content-end col-2">
                    <Button
                        variant="contained"
                        className="action-button bg-warning text-white rounded-0"
                        onClick={handleEditClicked}
                    >
                        <i className="fas fa-pencil-alt"></i>
                    </Button>
                    <Button
                        variant="contained"
                        className="ml-2 action-button bg-primary text-white rounded-0"
                        onClick={handleSecurityClicked}
                    >
                        <i className="fas fa-key"></i>
                    </Button>
                    <Button
                        variant="contained"
                        className="ml-2 action-button dark-red-button rounded-0"
                        onClick={handleViewCategorieslicked}
                    >
                        <i className="fas fa-bars"></i>
                    </Button>
                    <Button
                        variant="contained"
                        className="ml-2 action-button bg-danger text-white rounded-0"
                        onClick={handleDeleteClicked}
                    >
                        <i className="fas fa-trash"></i>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ForumDesktopItem;
